/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');
var Session = require('psa-core/Session');

var Scaffold = require('common/layout/Scaffold');
var ActivePageSection = require('common/util/ActivePageSection');

var GetUsersForRole = require('common/services/GetUsersForRole');
var GetAllComplaintLookups = require('../../complaint-dashboard/services/GetAllComplaintLookups');
var GetAllDepEntityLookups = require('../../../depository/common/services/GetAllEntityLookups');
var GetAllNonDepLicenseTypes = require('../../../non-depository/common/services/GetAllLicenseTypes');
var GetAllOrgLicenseLookups = require('../../../securities/common/services/GetAllOrgLicenseLookups');

var ConSerComplaintSearchView = require('../views/ConSerComplaintSearchView');

module.exports = function() {
  NProgress.start();
  NProgress.set(0.6);

  var searchLimit = Session.config.CM_ELASTICSEARCH_MAX_RESULTS || 1000;

  $.when(
    GetAllComplaintLookups(),
    GetAllDepEntityLookups(),
    GetAllNonDepLicenseTypes(),
    GetAllOrgLicenseLookups(),
    GetUsersForRole('CS - User')
  )
    .done(function(complaintLookups, depEntityLookups, nonDepLicenseTypes, orgLicenseLookups, caseManagers) {
      Scaffold.content.show(
        new ConSerComplaintSearchView({
          model: new Backbone.Model({
            searchLimit: searchLimit,
            complaintStatuses: complaintLookups.complaintStatuses,
            complaintType: complaintLookups.complaintType,
            weights: complaintLookups.weights,
            departments: complaintLookups.departments,
            depEntityTypes: depEntityLookups.entityTypes,
            nonDepLicenseTypes: nonDepLicenseTypes,
            secLicenseTypes: orgLicenseLookups.orgLicenseType,
            conserLicenseTypes: complaintLookups.departments2,
            caseManagers: caseManagers
          })
        })
      );
      // Clear out the previously visited page section whenever a user views
      // this page.
      ActivePageSection.empty();
      NavUtils.navigate('conser/complaint-search');
      NProgress.done();
    })
    .fail(function() {
      NProgress.done();
    });
};
